import '../Home_css/Dahlia.css';

 import checkicon from '../../Assets/Dahlia_images/Icons_checkmark.svg';


const  Products =()=>{
return(
  <section className="section1" id='home'>
  <div className="container">
    <div className="section-content">
      <div className="text-container">
        <h1>State-Of-The-Art<br/> Light Therapy System</h1>
        <div className="slider_points">
          <span className="slider_pt">
            <img src={checkicon} alt='check'/>
            Pain PTx™
          </span>
          <span className="slider_pt">
            <img src={checkicon} alt='check'/>
            Recovery PTx™
          </span>
          <span className="slider_pt">
            <img src={checkicon} alt='check'/>
            Weight Loss PTx™
          </span>
          <span className="slider_pt">
            <img src={checkicon} alt='check'/>
            Skin PTx™
          </span>
          <span className='slider_pt'>
            <img src={checkicon} alt='check'/>
            Circulation PTx™
          </span>
        </div>

       <div className='clearfix'></div>
       <div className="slider_btn">
        <button className="slider_btn" onClick={() => window.location.href = "#Treatments"}>View PrescriptiveTreatments <span>TM</span></button>
        </div>
        
      
      </div>
    </div>
    </div>
  </section>
);

}

export default Products;